export function isInFilteredList(Id, filteredBaseLayers) {
    const currentIndex = filteredBaseLayers.findIndex(
        (layer) => layer.id === Id
    );

    return currentIndex > -1;
}

export function getNextId(baseLayers, filteredBaseLayers, baseLayer, direction) {
    // Check if active base layer is in the filtered list

    var nextId;

    if (!baseLayer) {
        return baseLayers[0].id;
    }
    // Get position of currently activated baselayer in the baselayer list
    const currentIndex = baseLayers.findIndex(
        (layer) => layer.id === baseLayer
    );

    // In a loop get the next baselayer.
    // This is next layer in the baselayer list that is also in the filtered list.

    var continueLoop = true;
    var nextIndex = currentIndex;
    while (continueLoop) {

        nextIndex = getNextFromArray(baseLayers, nextIndex, direction);

        // If we are back at the start position there is no next possible background layer
        // so the next layer is the current layer
        if (nextIndex === currentIndex) {
            nextId = baseLayer;
            continueLoop = false;
        } else {
            // get the id and look it up in the filtered list.
            nextId = baseLayers[nextIndex].id;
            // When found in the filtered list end the loop. We have the next layer.
            if (isInFilteredList(nextId, filteredBaseLayers)) {
                continueLoop = false;
            }
        }
    }

    return nextId;
}

export function getNextFromArray(array, position, direction) {
    if (direction === 'in') {
        // Get next in baselayer list. Once past the end go to position 0.
        position = position + 1 >= array.length ? 0 : position + 1;
    } else {
        // Get previous in baselayer list. Once past the 0 go to position last.
        position = position - 1 < 0 ? array.length-1 : position - 1;
    }

    return position;
}
